import _ from 'lodash';
import { createActionHelpers } from 'vuex-loading';

export const CLEAR_MODULE = 'CLEAR_MODULE';
export const UPDATE_LOADING = 'UPDATE_LOADING';
export const UPDATE_TABLE_CTX = 'UPDATE_TABLE_CTX';
// export const RESET_TABLE_DATA = 'RESET_TABLE_DATA';
export const UPDATE_TABLE_DATA = 'UPDATE_TABLE_DATA';
export const ADD_FILTER_TO_MODEL = 'ADD_FILTER_TO_MODEL';
export const UPDATE_FORM_DATA = 'UPDATE_FORM_DATA';
export const UPDATE_ERROR = 'UPDATE_ERROR';
export const UPDATE_SEARCHED_CLIENTS = 'UPDATE_SEARCHED_CLIENTS';
export const UPDATE_SEARCHING_OPERATIONS = 'UPDATE_SEARCHING_OPERATIONS';
export const UPDATE_SEARCHED_OPERATIONS = 'UPDATE_SEARCHED_OPERATIONS';
export const UPDATE_FIND_RESULT = 'UPDATE_FIND_RESULT';

export const submitSearchFichasInmobiliariasAction = 'submitSearchFichasInmobiliariasAction';
export const resetSearchedFichasInmobiliariasAction = 'resetSearchedFichasInmobiliariasAction';
export const setFilterAction = 'setFilterAction';
export const searchOperationNameAction = 'searchOperationNameAction';
export const changeErrorStatus = 'changeErrorStatus';
export const createClientAction = 'createClientAction';
export const searchByFilterAction = 'searchByFilterAction';

const { startLoading, endLoading } = createActionHelpers({
  moduleName: 'loading',
});

async function fichaInmobiliariaOperation(ops, fichas) {
  _.forOwn(ops, (op) => {
    if (op && op.gestionInmobiliaria) {
      if (fichas && fichas.length > 0) {
        fichas.forEach((ficha) => {
          if (op.gestionInmobiliaria === ficha.id) {
            ficha.operation = op.id;
          }
        });
      }
    }
  });
  return fichas;
}

const initState = {
  error: '',
  loading: false,
  searchedOperations: [],
  searchingOperations: false,
  searchedResults: [],
  findResult: false,
  formModel: {
    filtro: '',
  },
  tableCtx: {
    currentPage: 1,
    perPage: 10,
    filter: '',
    sortBy: '',
    sortDesc: false,
  },
  tableData: [],
};

export default {
  namespaced: true,
  state: Object.assign({}, initState),
  mutations: {
    [CLEAR_MODULE](state) {
      Object.assign(state, initState);
    },
    [UPDATE_LOADING](state, loading) {
      state.loading = loading;
    },
    [UPDATE_ERROR](state, msg) {
      state.error = msg;
    },
    [UPDATE_TABLE_CTX](state, model) {
      state.tableCtx = Object.assign({}, state.tableCtx, model);
    },
    [ADD_FILTER_TO_MODEL](state, filter) {
      state.formModel.filtro = filter;
    },
    [UPDATE_TABLE_DATA](state, lista) {
      state.tableData = lista;
    },
    [UPDATE_SEARCHED_CLIENTS](state, lista) {
      state.searchedClients = lista;
    },
    [UPDATE_FORM_DATA](state, payload) {
      payload.filtro = state.formModel.filtro;
      state.formModel = payload;
    },
    [UPDATE_SEARCHING_OPERATIONS](state, newValue) {
      state.searchingOperations = newValue;
    },
    [UPDATE_SEARCHED_OPERATIONS](state, lista) {
      state.searchedOperations = lista;
    },
    [UPDATE_FIND_RESULT](state, payload) {
      state.findResult = payload;
    },
  },
  actions: {
    [submitSearchFichasInmobiliariasAction]({ commit, dispatch, rootGetters }, payload) {
      startLoading(dispatch, 'buscar fichaInmobiliaria');
      commit(UPDATE_LOADING, true);
      commit(UPDATE_ERROR, '');
      commit(UPDATE_FORM_DATA, payload.model);
      const { model } = payload;
      const operations = rootGetters['operation_model/entitiesGetter'];
      const op = operations[payload.operation.id];
      const fetchConfig = {};
      _.forOwn(model, (value, key) => {
        if (value && value !== '') {
          if (key === 'nombre') {
            fetchConfig.nombreFilter = {
              modelName: 'cardTitle',
              operator: 'CONTAINS',
              value,
              path: 'card_title',
            };
          } else if (key === 'finalidad') {
            fetchConfig.finalidad = {
              modelName: 'finalidad',
              operator: 'CONTAINS',
              value,
              path: 'finalidad',
            };
          } else if (key === 'operacion') {
            if (op && op.gestionInmobiliaria) {
              fetchConfig.uuid = {
                modelName: 'uuid',
                operator: '=',
                value: op.gestionInmobiliaria,
                path: 'uuid',
              };
            }
          }
        }
      });
      return dispatch('realtyManagement_model/fetchAction', fetchConfig, { root: true })
        .then((results) => {
          fichaInmobiliariaOperation(operations, results.entities)
            .then((res) => {
              if (res.length >= 0) {
                commit(UPDATE_TABLE_DATA, res);
              } else {
                commit(UPDATE_TABLE_DATA, []);
              }
              commit(UPDATE_LOADING, false);
              commit(UPDATE_FIND_RESULT, true);
              endLoading(dispatch, 'buscar fichaInmobiliaria');
            });
        })
        .catch((error) => {
          dispatch('updateErrorOverlay', error, { root: true });
          endLoading(dispatch, 'buscar fichaInmobiliaria');
        });
    },
    [changeErrorStatus]({ commit }, msg) {
      commit(UPDATE_ERROR, msg);
    },
    [resetSearchedFichasInmobiliariasAction]({ commit }) {
      commit(CLEAR_MODULE);
    },
    [searchOperationNameAction]({ commit, dispatch }, name) {
      commit(UPDATE_SEARCHING_OPERATIONS, true);
      commit(UPDATE_SEARCHED_OPERATIONS, []);
      return dispatch('operation_model/fetchAction', {
        nombre: {
          modelName: 'title',
          operator: 'CONTAINS',
          value: name,
          path: 'title',
        },
      }, { root: true })
        .then((lista) => {
          const { entities } = lista;
          commit(UPDATE_SEARCHING_OPERATIONS, false);
          commit(UPDATE_SEARCHED_OPERATIONS, entities);
        })
        .catch(() => {
          commit(UPDATE_SEARCHING_OPERATIONS, false);
        });
    },
    [searchByFilterAction]({ commit, dispatch, rootGetters }, filter) {
      startLoading(dispatch, 'buscar fichaInmobiliaria');
      commit(UPDATE_LOADING, true);
      commit(UPDATE_ERROR, '');
      const operations = rootGetters['operation_model/entitiesGetter'];
      let config = {};
      switch (filter) {
        case 'Ver todas':
          config = {};
          break;
        case 'Visibles en App':
          config = {
            viewVisibles: {
              modelName: 'published',
              operator: '=',
              value: 1,
              path: 'published',
            },
          };
          break;
        case 'No visibles en App':
          config = {
            viewNoVisibles: {
              modelName: 'published',
              operator: '=',
              value: 0,
              path: 'published',
            },
          };
          break;
        default:
          break;
      }
      dispatch('realtyManagement_model/fetchAction', config, { root: true }).then((result) => {
        const { entities } = result;
        fichaInmobiliariaOperation(operations, entities)
          .then((res) => {
            if (Array.isArray(res) && res.length > 0) {
              commit(UPDATE_TABLE_DATA, res);
              commit(UPDATE_LOADING, false);
            } else {
              commit(UPDATE_TABLE_DATA, []);
            }
            commit(UPDATE_LOADING, false);
            commit(UPDATE_FIND_RESULT, true);
            endLoading(dispatch, 'buscar fichaInmobiliaria');
          });
      })
        .catch((error) => {
          dispatch('updateErrorOverlay', error, { root: true });
          endLoading(dispatch, 'buscar fichaInmobiliaria');
        });
    },
  },
  getters: {
    isLoading: state => state.loading,
    error: state => state.error,
    existError: state => state.error !== '',
    searchedResults: state => state.tableData,
    searchedOperations: state => state.searchedOperations,
    isSearchingOperations: state => state.searchingOperations,
    findResult: state => state.findResult,
  },
};



// WEBPACK FOOTER //
// ./src/features/menu-ficha-inmobiliaria/store.js